<kit-page-header [backgroundWhite]="false"
                 [description]="'Download reports to use for external accounting software'"
                 [fullWidthDescription]="true"
                 [section]="'Retailer External Accounting Software Downloads'"
                 [title]="'View and download external software reports'"
></kit-page-header>

@if (loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="fx-col page-padding page-content fx-gap-20">
  <div>
    <div class="fx-row fx-center fx-gap-10">
      <mat-form-field appearance="outline">
        <mat-label>Month</mat-label>
        <mat-select (selectionChange)="checkReload()" [(ngModel)]="selectedMonth">
          <mat-option *ngFor="let month of months" [value]="month.value">{{ month.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Year</mat-label>
        <mat-select (selectionChange)="checkReload()" [(ngModel)]="selectedYear"
                    [disabled]="(selectedMonth === null || !!(loading$ | async))">
          <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Software</mat-label>
        <mat-select (selectionChange)="checkReload()" [(ngModel)]="selectedSoftware"
                    [disabled]="selectedMonth == null || selectedYear == null || !!(loading$ | async)">
          <mat-option *ngFor="let software of softwares" [value]="software">{{ software }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <ng-container *ngIf="selectedSoftware != null && selectedMonth != null && selectedYear != null"
                [ngSwitch]="selectedSoftware">
    <div *ngSwitchCase="'MRI'">
      <app-mri-bulk-download [reload]="reloadSubject.asObservable()" [selectedMonth]="selectedMonth"
                             [selectedYear]="selectedYear"></app-mri-bulk-download>
    </div>
  </ng-container>
</div>
